import React from "react"
import styled from "styled-components"

const IframeWrapper = styled.div`
  position: relative;

  &::before {
    content: "";
    display: block;
    padding-bottom: calc(100% / var(--aspect-ratio));
  }

  @supports (aspect-ratio: 1) {
    aspect-ratio: var(--aspect-ratio);

    &::before {
      content: none;
    }
  }

  > iframe {
    position: absolute;
    inset: 0;
    height: 100%;
    width: 100%;
  }
`

type ResponsiveIframeProps = {
  src: string
  title: string
  width?: number
  height?: number
}

export const ResponsiveIframe = ({
  src,
  width = 1600,
  height = 900,
  title,
  ...rest
}: ResponsiveIframeProps): React.ReactElement => {
  const aspectRatio = width / height

  return (
    <IframeWrapper style={{ "--aspect-ratio": aspectRatio } as React.CSSProperties}>
      <iframe title={title} src={src} width={width} height={height} frameBorder="0" {...rest} />
    </IframeWrapper>
  )
}
